import React from 'react'

export default function Footer() {
    return (
        <>
            <footer className='bg-[#14212b] dark:bg-neutral-700 lg:text-left'>
                <div className="max-w-[90rem] w-full mx-auto px-4 md:px-6 lg:px-8" bis_skin_checked="1"><div className="p-4 text-xl text-center text-white" bis_skin_checked="1">All rights reserved @2023 | Website Developed &amp; Maintained by <a className="winbings" alt="Winbings - A Leading Software Development Company " target="_blank" href="https://www.winbings.com/">Winbings</a></div></div>
            </footer>
        </>
    )
}
